import { AppKitButton } from '@reown/appkit/react'

export default function WalletButton() {
  return (
    <div style={{ display: 'inline-block' }}>
      <AppKitButton />
    </div>
  )
}
